import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

assignBudgetsStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        /* &:hover {
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("text.accent")} !important;
    } */

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
       
    } */
        }
    `,
};
assignBudgetsStyles.titleGridItem = {
    width: [12, 12, 8, 8, 8],
    css: css`
        padding: 15px;
        padding-left: 0;
    `,
};
assignBudgetsStyles.saveButton = {
    css: css`
        margin-left: 10px;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
assignBudgetsStyles.tableGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        padding: 15px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    overflow: auto;
                    white-space: nowrap;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
assignBudgetsStyles.periodHeader = {
    css: css`
        white-space: nowrap !important;
    `,
};
assignBudgetsStyles.searchUserWrapper = {
    css: css`
        display: inline-block;
        margin-right: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 30px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "min",
            )}
    `,
};
